// Global Controls - Domain & Basis Switchers for CmdBar
import { basis, domain } from '../../state/globalSignals.js'

export default function GlobalControls() {
  // Basis labels
  const basisLabels = {
    'abs': 'Absolute',
    'grav': 'Gravimetric',
    'vol': 'Volumetric'
  }
  
  // Basis short labels for compact display
  const basisShort = {
    'abs': 'Abs',
    'grav': 'Grav',
    'vol': 'Vol'
  }
  
  // Domain labels
  const domainLabels = {
    'energy-power': 'Energy & Power',
    'capacity-current': 'Capacity & Current'
  }
  
  // Domain icons
  const domainIcons = {
    'energy-power': (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
      </svg>
    ),
    'capacity-current': (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"/>
        <line x1="8" y1="12" x2="21" y2="12"/>
        <line x1="8" y1="18" x2="21" y2="18"/>
        <line x1="3" y1="6" x2="3.01" y2="6"/>
        <line x1="3" y1="12" x2="3.01" y2="12"/>
        <line x1="3" y1="18" x2="3.01" y2="18"/>
      </svg>
    )
  }
  
  const cycleBasis = () => {
    const bases = ['abs', 'grav', 'vol']
    const currentIndex = bases.indexOf(basis.value)
    const nextIndex = (currentIndex + 1) % bases.length
    basis.value = bases[nextIndex]
  }
  
  const toggleDomain = () => {
    domain.value = domain.value === 'energy-power' 
      ? 'capacity-current' 
      : 'energy-power'
  }
  
  return (
    <div className="global-controls" data-tour="welcome-global-controls">
      {/* Domain Switcher */}
      <button 
        className="global-control-btn domain-switcher"
        onClick={toggleDomain}
        title={`Switch to ${domain.value === 'energy-power' ? 'Capacity & Current' : 'Energy & Power'}`}
        aria-label="Toggle domain"
      >
        <span className="control-icon">
          {domainIcons[domain.value]}
        </span>
        <span className="control-label">
          {domain.value === 'energy-power' ? 'E/P' : 'C/I'}
        </span>
      </button>
      
      {/* Basis Switcher */}
      <button 
        className="global-control-btn basis-switcher"
        onClick={cycleBasis}
        title={`Current: ${basisLabels[basis.value]} - Click to cycle`}
        aria-label="Cycle basis"
      >
        <span className="control-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {basis.value === 'abs' && (
              <rect x="3" y="3" width="18" height="18" rx="2"/>
            )}
            {basis.value === 'grav' && (
              <>
                <path d="M12 2v20"/>
                <path d="m8 18 4 4 4-4"/>
                <path d="m8 6 4-4 4 4"/>
              </>
            )}
            {basis.value === 'vol' && (
              <>
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
              </>
            )}
          </svg>
        </span>
        <span className="control-label">
          {basisShort[basis.value]}
        </span>
      </button>
    </div>
  )
}
